module.exports = __webpack_public_path__ + "static/AccesstoNewTech-82dee1db8b05164365a6ba1a965226e8.svg";